// The "This already happened" note on a card whose moment has passed (CardSummary.elapsed).
// Pure so the wording is tested; the caller formats the date.
import type { CardElapsed } from "@shared/api";

/** A quote longer than this reads as a paragraph, not a clue; the date alone is enough. */
export const SHORT_QUOTE_CHARS = 60;

/** The email's own words for the moment, when they are short enough to repeat; else null. */
export function shortQuote(quote: string): string | null {
  const text = quote
    .replace(/\s+/g, " ")
    .trim()
    .replace(/^["“”'‘’]+|["“”'‘’]+$/g, "")
    .trim();
  return text && text.length < SHORT_QUOTE_CHARS ? text : null;
}

export interface ElapsedWords {
  headline: string;
  /** Second line, only when the email offers a recording or replay worth keeping. */
  recording: string | null;
}

/** `when` is the moment already formatted for the reader (formatShortDateTime(elapsed.at)). */
export function elapsedWords(elapsed: Pick<CardElapsed, "quote" | "recording">, when: string) {
  const quote = shortQuote(elapsed.quote);
  const words: ElapsedWords = {
    headline: quote
      ? `This already happened · ${when} · the email said “${quote}”`
      : `This already happened · ${when}`,
    recording: elapsed.recording
      ? "The email has a recording or replay link, so Save it before you archive."
      : null,
  };
  return words;
}
